import { showError, showSuccess } from '../../Components/reuse/Toast';
import api from '../../api/axios';
import { validateToken } from './validateAction';

// Action Types
export const GET_SUGGESTED_QUESTIONS_REQUEST = 'GET_SUGGESTED_QUESTIONS_REQUEST';
export const GET_SUGGESTED_QUESTIONS_SUCCESS = 'GET_SUGGESTED_QUESTIONS_SUCCESS';
export const GET_SUGGESTED_QUESTIONS_FAILURE = 'GET_SUGGESTED_QUESTIONS_FAILURE';

export const CREATE_SUGGESTED_QUESTION_REQUEST = 'CREATE_SUGGESTED_QUESTION_REQUEST';
export const CREATE_SUGGESTED_QUESTION_SUCCESS = 'CREATE_SUGGESTED_QUESTION_SUCCESS';
export const CREATE_SUGGESTED_QUESTION_FAILURE = 'CREATE_SUGGESTED_QUESTION_FAILURE';

export const UPDATE_SUGGESTED_QUESTION_REQUEST = 'UPDATE_SUGGESTED_QUESTION_REQUEST';
export const UPDATE_SUGGESTED_QUESTION_SUCCESS = 'UPDATE_SUGGESTED_QUESTION_SUCCESS';
export const UPDATE_SUGGESTED_QUESTION_FAILURE = 'UPDATE_SUGGESTED_QUESTION_FAILURE';

export const DELETE_SUGGESTED_QUESTION_REQUEST = 'DELETE_SUGGESTED_QUESTION_REQUEST';
export const DELETE_SUGGESTED_QUESTION_SUCCESS = 'DELETE_SUGGESTED_QUESTION_SUCCESS';
export const DELETE_SUGGESTED_QUESTION_FAILURE = 'DELETE_SUGGESTED_QUESTION_FAILURE';

export const GET_WIDGET_COLOR_REQUEST = 'GET_WIDGET_COLOR_REQUEST';
export const GET_WIDGET_COLOR_SUCCESS = 'GET_WIDGET_COLOR_SUCCESS';
export const GET_WIDGET_COLOR_FAILURE = 'GET_WIDGET_COLOR_FAILURE';

export const SAVE_WIDGET_COLOR_REQUEST = 'SAVE_WIDGET_COLOR_REQUEST';
export const SAVE_WIDGET_COLOR_SUCCESS = 'SAVE_WIDGET_COLOR_SUCCESS';
export const SAVE_WIDGET_COLOR_FAILURE = 'SAVE_WIDGET_COLOR_FAILURE';

export const SAVE_TERMS_CONDITIONS_REQUEST = 'SAVE_TERMS_CONDITIONS_REQUEST';
export const SAVE_TERMS_CONDITIONS_SUCCESS = 'SAVE_TERMS_CONDITIONS_SUCCESS';
export const SAVE_TERMS_CONDITIONS_FAILURE = 'SAVE_TERMS_CONDITIONS_FAILURE';

// Action Creators
export const getSuggestedQuestions = (page = 1, limit = 25) => async (dispatch) => {
  dispatch({ type: GET_SUGGESTED_QUESTIONS_REQUEST });
  
  try {
    const response = await api.get(`suggestedQuestions/get?page=${page}&limit=${limit}`);
    
    if (response.data.success) {
      dispatch({ 
        type: GET_SUGGESTED_QUESTIONS_SUCCESS, 
        payload: response.data
      });
    } else {
      dispatch({ 
        type: GET_SUGGESTED_QUESTIONS_FAILURE, 
        error: response.data.message || 'Failed to fetch suggested questions' 
      });
      showError(response.data.message || 'Failed to fetch suggested questions');
    }
  } catch (error) {
    console.error('Failed to fetch suggested questions:', error);
    dispatch({ 
      type: GET_SUGGESTED_QUESTIONS_FAILURE, 
      error: 'Failed to fetch suggested questions' 
    });
    showError('Failed to fetch suggested questions');
  }
};

export const createSuggestedQuestion = (questionData, refreshCallback) => async (dispatch) => {
  dispatch({ type: CREATE_SUGGESTED_QUESTION_REQUEST });
  
  try {
    const response = await api.post('suggestedQuestions/create', questionData);
    
    if (response.data.success) {
      dispatch({ 
        type: CREATE_SUGGESTED_QUESTION_SUCCESS, 
        payload: {
          data: response.data.data,
          message: response.data.message || 'Question created successfully!'
        }
      });
      showSuccess('Question created successfully!');
      // Refresh the questions list after creation
      if (refreshCallback) {
        refreshCallback();
      } else {
        dispatch(getSuggestedQuestions(1, 25));
      }
    } else {
      dispatch({ 
        type: CREATE_SUGGESTED_QUESTION_FAILURE, 
        error: response.data.message || 'Failed to create question' 
      });
      showError(response.data.message || 'Failed to create question');
    }
  } catch (error) {
    console.error('Failed to create question:', error);
    dispatch({ 
      type: CREATE_SUGGESTED_QUESTION_FAILURE, 
      error: 'Failed to create question' 
    });
    showError('Failed to create question');
  }
};

export const updateSuggestedQuestion = (questionId, questionData, refreshCallback) => async (dispatch) => {
  dispatch({ type: UPDATE_SUGGESTED_QUESTION_REQUEST });
  
  try {
    const response = await api.put(`suggestedQuestions/update/${questionId}`, questionData);
    
    if (response.data.success) {
      dispatch({ 
        type: UPDATE_SUGGESTED_QUESTION_SUCCESS, 
        payload: {
          data: response.data.data,
          message: response.data.message || 'Question updated successfully!'
        }
      });
      showSuccess('Question updated successfully!');
      // Refresh the questions list after update
      if (refreshCallback) {
        refreshCallback();
      } else {
        dispatch(getSuggestedQuestions(1, 25));
      }
    } else {
      dispatch({ 
        type: UPDATE_SUGGESTED_QUESTION_FAILURE, 
        error: response.data.message || 'Failed to update question' 
      });
      showError(response.data.message || 'Failed to update question');
    }
  } catch (error) {
    console.error('Failed to update question:', error);
    dispatch({ 
      type: UPDATE_SUGGESTED_QUESTION_FAILURE, 
      error: 'Failed to update question' 
    });
    showError('Failed to update question');
  }
};

export const deleteSuggestedQuestion = (questionId, refreshCallback) => async (dispatch) => {
  dispatch({ type: DELETE_SUGGESTED_QUESTION_REQUEST });
  
  try {
    const response = await api.delete(`suggestedQuestions/delete/${questionId}`);
    
    if (response.data.success) {
      dispatch({ 
        type: DELETE_SUGGESTED_QUESTION_SUCCESS, 
        payload: {
          data: response.data.data,
          message: response.data.message || 'Question deleted successfully!'
        }
      });
      showSuccess('Question deleted successfully!');
      // Refresh the questions list after deletion
      if (refreshCallback) {
        refreshCallback();
      } else {
        dispatch(getSuggestedQuestions(1, 25));
      }
    } else {
      dispatch({ 
        type: DELETE_SUGGESTED_QUESTION_FAILURE, 
        error: response.data.message || 'Failed to delete question' 
      });
      showError(response.data.message || 'Failed to delete question');
    }
  } catch (error) {
    console.error('Failed to delete question:', error);
    dispatch({ 
      type: DELETE_SUGGESTED_QUESTION_FAILURE, 
      error: 'Failed to delete question' 
    });
    showError('Failed to delete question');
  }
};

export const getWidgetColor = () => async (dispatch) => {
  dispatch({ type: GET_WIDGET_COLOR_REQUEST });
  
  try {
    const response = await api.get('widgetColors/getColour');
    
    if (response.data.success) {
      dispatch({ 
        type: GET_WIDGET_COLOR_SUCCESS, 
        payload: response.data
      });
    } else {
      dispatch({ 
        type: GET_WIDGET_COLOR_FAILURE, 
        error: response.data.message || 'Failed to fetch widget color' 
      });
      showError(response.data.message || 'Failed to fetch widget color');
    }
  } catch (error) {
    console.error('Failed to fetch widget color:', error);
    dispatch({ 
      type: GET_WIDGET_COLOR_FAILURE, 
      error: 'Failed to fetch widget color' 
    });
    // Keep UI usable on /test-zone if color API fails
    // Avoid double-toasting across pages; log only
    // showError('Failed to fetch widget color');
  }
};

export const saveWidgetColor = (color) => async (dispatch) => {
  dispatch({ type: SAVE_WIDGET_COLOR_REQUEST });
  
  try {
    const response = await api.post('widgetColors/saveColour', { color });
    
    if (response.data.success) {
      dispatch({ 
        type: SAVE_WIDGET_COLOR_SUCCESS, 
        payload: { color }
      });
      showSuccess('Widget color saved successfully!');
    } else {
      dispatch({ 
        type: SAVE_WIDGET_COLOR_FAILURE, 
        error: response.data.message || 'Failed to save widget color' 
      });
      showError(response.data.message || 'Failed to save widget color');
    }
  } catch (error) {
    console.error('Failed to save widget color:', error);
    dispatch({ 
      type: SAVE_WIDGET_COLOR_FAILURE, 
      error: 'Failed to save widget color' 
    });
    showError('Failed to save widget color');
  }
};

export const saveTermsAndConditions = (termCondition) => async (dispatch) => {
  dispatch({ type: SAVE_TERMS_CONDITIONS_REQUEST });
  
  try {
    const response = await api.put('widgetColors/updateUserSettings', { termCondition });
    
    if (response.data.success) {
      dispatch({ 
        type: SAVE_TERMS_CONDITIONS_SUCCESS, 
        payload: { termCondition }
      });
      showSuccess(response?.data?.message || 'Terms and conditions saved successfully!');
      
      // Validate token to update auth state with new user data
      await dispatch(validateToken());
    } else {
      dispatch({ 
        type: SAVE_TERMS_CONDITIONS_FAILURE, 
        error: response.data.message || 'Failed to save terms and conditions' 
      });
      showError(response.data.message || 'Failed to save terms and conditions');
    }
  } catch (error) {
    console.error('Failed to save terms and conditions:', error);
    dispatch({ 
      type: SAVE_TERMS_CONDITIONS_FAILURE, 
      error: 'Failed to save terms and conditions' 
    });
    showError('Failed to save terms and conditions');
  }
};

export const saveReturnEmail = (returnEmail) => async (dispatch) => {
  dispatch({ type: SAVE_TERMS_CONDITIONS_REQUEST });
  
  try {
    const response = await api.put('widgetColors/updateUserSettings', { returnEmail });
    
    if (response.data.success) {
      dispatch({ 
        type: SAVE_TERMS_CONDITIONS_SUCCESS, 
        payload: { returnEmail }
      });
      showSuccess(response?.data?.message || 'Return email saved successfully!');
      
      // Validate token to update auth state with new user data
      await dispatch(validateToken());
    } else {
      dispatch({ 
        type: SAVE_TERMS_CONDITIONS_FAILURE, 
        error: response.data.message || 'Failed to save return email' 
      });
      showError(response.data.message || 'Failed to save return email');
    }
  } catch (error) {
    console.error('Failed to save return email:', error);
    dispatch({ 
      type: SAVE_TERMS_CONDITIONS_FAILURE, 
      error: 'Failed to save return email' 
    });
    showError('Failed to save return email');
  }
};
